module.exports = __webpack_public_path__ + "static/media/seoul-2033-yousijin.60104489.jpg";